import { DialogTitle } from "@mui/material";
import { workOrderBusiness } from "api/bussiness/work-order/work-order-bussiness";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { IAddWorkOrder } from "mobx-stores/_models/work-order/work-order";
import { useStores } from "mobx-stores/_root-store";
import { useResetCustomerDependentControls } from "pages/common/hooks/use-reset-customer-dependent-controls";
import { useCallback, useMemo } from "react";
import { DialogComplexContent } from "share-components/templates/form/dialog-complex-form/dialog-complex-content";
import { DialogComplexFormContainer } from "share-components/templates/form/dialog-complex-form/dialog-complex-form";
import { DialogComplexFormArrayContainer } from "share-components/templates/form/dialog-complex-form/dialog-complex-form-array";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getAddWorkOrderFormSchema } from "../schema";

export const AddWorkOrder = observer(() => {
  const {
    workOrderManagement: { openNew, getWorkOrders, setProp },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    getControlArray,
    submitHandler,
  } = useForm<IAddWorkOrder>((form) => getAddWorkOrderFormSchema(form), {
    date: dateTimeToUTCString(dayjs()),
    woNumber: "",
    customerId: "",
    purchaseOrderId: "",
    note: "",
    items: [
      {
        amount: 0,
        note: "",
        productId: "",
      },
    ],
  });

  const saveHandler = useCallback(
    async (data: IAddWorkOrder) => {
      try {
        await workOrderBusiness.add(data);
        await getWorkOrders();
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getWorkOrders, setProp],
  );

  const itemControl = useMemo(() => {
    return getControl("items");
  }, [getControl]);

  const customerControl = useMemo(() => {
    return getControl("customerId");
  }, [getControl]);

  useResetCustomerDependentControls({
    customerId: customerControl.value,
    arrayChildControls: [
      {
        arrayControl: itemControl,
        childControlName: "productId",
      },
    ],
  });

  const workOrderItems = useMemo(() => {
    return getControlArray("items");
  }, [getControlArray]);

  // const removeRowHandler = useCallback(
  //   (idx: number) => {
  //     itemControl.removeChildByIndex(idx);
  //   },
  //   [itemControl]
  // );

  // const addNewWorkOrderItemRow = useCallback(() => {
  //   itemControl.addNewChild();
  // }, [itemControl]);

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"md"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm lệnh sản xuất</DialogTitle>
      <DialogComplexContent>
        <DialogComplexFormContainer>
          <DynamicForm controls={controls}></DynamicForm>
        </DialogComplexFormContainer>
        <DialogComplexFormArrayContainer label={itemControl.label}>
          {workOrderItems && workOrderItems.length > 0 && (
            <DynamicFormArray
              controlSpacing={2}
              containerProps={{
                sx: {
                  marginTop: "10px",
                  marginBottom: "10px",
                },
              }}
              children={workOrderItems}
            ></DynamicFormArray>
          )}
        </DialogComplexFormArrayContainer>
      </DialogComplexContent>
    </DialogForm>
  );
});
